<template>


<v-container>
  <v-btn @click="teste">Teste</v-btn>
  
  <v-btn @click="teste2">Teste2</v-btn>
  
  <v-btn @click="teste3">Teste3</v-btn>

  

    <div style="background-color:green">
      <Moveable
        class="moveable"
        v-bind="moveable"
        @drag="handleDrag"
        @resize="handleResize"
        @scale="handleScale"
        @rotate="handleRotate"
        @warp="handleWarp"
    
      >
        <span>Vue Moveable</span>
       

      </Moveable>

         <v-switch
      v-model="moveable.draggable"
      color="primary"
      label="Draggable"
    ></v-switch>
  
        <v-switch
      v-model="moveable.resizable"
      color="primary"
      label="resizable"
    ></v-switch>
  
        <v-switch
      v-model="moveable.scalable"
      color="primary"
      label="scalable"
    ></v-switch>

    </div>
      

</v-container>

</template>

<script>
/* eslint-disable no-param-reassign,no-unused-expressions,no-console */
import Moveable from "vue-moveable";


export default {
  name: "Templates",
  components: {
    Moveable
  },
  data: () => ({
      top:12,
    moveable: {
      draggable: true,
      throttleDrag: 1,
      resizable: false,
      throttleResize: 1,
      keepRatio: false,
      scalable: true,
      throttleScale: 0.01,
      rotatable: true,
      throttleRotate: 0.2,
      pinchable: false,
      origin: true
    },
    states: {
      scalable: "Scalable",
      resizable: "Resizable",
      warpable: "Warpable"
    },
    currentState: "scalable"
  }),
  methods: {
     async teste(){
       // alert('teste');

          //      const toDataURL = url => fetch(url)
          //   .then(response => response.blob())
          //   .then(blob => new Promise((resolve, reject) => {
          //     const reader = new FileReader()
          //     reader.onloadend = () => resolve(reader.result)
          //     reader.onerror = reject
          //     reader.readAsDataURL(blob)
          //   }))


          // toDataURL('https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68')
          //   .then(dataUrl => {
          //     console.log('RESULT:', dataUrl)
          //   })

            var url = "https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68";
            // const response = await fetch(url, {
            //   method: 'GET', // *GET, POST, PUT, DELETE, etc.
            //   mode: 'no-cors', // no-cors, *cors, same-origin
            //  // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            //   //credentials: 'same-origin', // include, *same-origin, omit
            //   headers: {
            //    // 'Content-Type': 'application/json'
            //     // 'Content-Type': 'application/x-www-form-urlencoded',
            //   },
            //   //redirect: 'follow', // manual, *follow, error
            //   //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            // //  body: JSON.stringify(data) // body data type must match "Content-Type" header
            // }) .then((res) => {
            //     console.log("first ans")
            //     console.log(res);

            //     return res.blob();
            //   })
            //   .then((json) => {
            //     console.log("sec ans")
            //     console.log(json);
            //         console.log("User added")

            //     return json;
            //   });
            
             //console.log(response.blob())

            //console.log( response.json()) // parses JSON response into native JavaScript objects

          const toDataURL = url => fetch(url)
            .then(
              response => response.blob()
              
              )
            .then(blob => new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onloadend = () => resolve(reader.result)
              reader.onerror = reject
              reader.readAsDataURL(blob)
            }))

          //http://www.hebelsolar.com/images/solar/proposta.png
          //https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68
          
         // var imageUrl = 'http://www.hebelsolar.com/images/solar/proposta.png';
         //var imageUrl = "https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68";
          var imageUrl = "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/tmcLogo.png?alt=media&token=84c408cc-8d0c-4758-a40a-88bb95eafaf8";
          toDataURL(imageUrl)
            .then(dataUrl => {
              console.log('RESULT:', dataUrl)
            })

    },

    teste2(){
          var imageUrl = "https://firebasestorage.googleapis.com/v0/b/apptmcsolar.appspot.com/o/APP3.png?alt=media&token=1a2f2431-a0b3-4a2f-ba9c-9cfda9c7ec68";
     
        // This can be downloaded directly:
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = function(event) {
          var blob = xhr.response;
          alert(JSON.stringify(blob))
        };
        xhr.open('GET', imageUrl);
        xhr.send();

        // Or inserted into an <img> element:
        // var img = document.getElementById('myimg');
        // img.src = url;


    },

    async teste3(){
         var url = "https://firebasestorage.googleapis.com/v0/b/hebelsolar.appspot.com/o/tmcLogo.png?alt=media&token=84c408cc-8d0c-4758-a40a-88bb95eafaf8";
        var c  = await fetch(url, {
                        method: 'GET',
                        
                      })
                .then((res) => {
                  console.log("first ans")
                  console.log(res);

                  return res.blob();
                })
                .then((blob) => {
                    return blob;
                    
                });
                console.log(c);
                 //var x = await readFileAsync(blob);
                   
                      //return c;
      var x = await this.readFileAsync(c);


       console.log(x);
    },

    async readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        //reader.readAsArrayBuffer(file);
        reader.readAsDataURL(file)

      })
    },
    handleDrag({ target, transform }) {
      console.log("onDrag", transform);
      target.style.transform = transform;
    },
    handleResize({ target, width, height }) {
      console.log("onResize", width, height);
      target.style.width = `${width}px`;
      target.style.height = `${height}px`;
    },
    handleScale({ target, transform }) {
      console.log("onScale", transform);
      target.style.transform = transform;
    },
    handleRotate({ target, transform }) {
      console.log("onRotate", transform);
      target.style.transform = transform;
    },
    handleWarp({ target, transform }) {
      console.log("onWarp", transform);
      target.style.transform = transform;
    },
    clearAllStates() {
      Object.keys(this.states).forEach(key => {
        this.moveable[key] = false;
      });
    }
  },
  watch: {
    currentState(newState) {
      this.clearAllStates();
      this.moveable[newState] = true;
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600&display=swap");
@import url("https://fonts.googleapis.com/css?family=Roboto:100&display=swap");

</style>